import { WHATSAPP_URL } from "@/lib/constants";
import { useT } from "@/i18n";

const WhatsAppIcon = () => (
  <svg viewBox="0 0 32 32" fill="currentColor" className="w-7 h-7" aria-hidden="true">
    <path d="M16.004 3C9.383 3 4 8.383 4 15.004c0 2.117.553 4.185 1.604 6.014L4 29l8.16-1.57a11.94 11.94 0 0 0 3.844.633h.004C22.625 28.063 28 22.68 28 16.059 28 12.85 26.75 9.836 24.48 7.566A11.92 11.92 0 0 0 16.004 3zm0 22.047h-.004a9.94 9.94 0 0 1-3.508-.645l-.25-.098-4.844.934.98-4.727-.164-.258a9.97 9.97 0 0 1-1.527-5.25c0-5.516 4.492-10.004 10.012-10.004 2.672 0 5.184 1.043 7.07 2.93a9.93 9.93 0 0 1 2.926 7.078c0 5.52-4.488 10.04-10.691 10.04zm5.484-7.492c-.301-.152-1.777-.879-2.055-.98-.273-.098-.473-.152-.672.152-.199.301-.77.98-.945 1.184-.176.199-.348.223-.648.074-.301-.152-1.27-.469-2.418-1.492-.895-.797-1.496-1.781-1.672-2.082-.176-.301-.02-.465.133-.613.133-.133.301-.348.449-.523.152-.176.199-.301.301-.5.098-.199.047-.375-.027-.527-.074-.152-.672-1.617-.918-2.215-.242-.582-.488-.504-.672-.512l-.57-.012c-.199 0-.523.074-.797.375-.273.301-1.043 1.02-1.043 2.484 0 1.465 1.07 2.883 1.219 3.082.152.199 2.105 3.215 5.098 4.508.711.309 1.266.492 1.699.629.715.227 1.363.195 1.879.117.574-.086 1.777-.727 2.027-1.426.25-.703.25-1.305.176-1.43-.074-.125-.273-.199-.574-.352z" />
  </svg>
);

export const WhatsAppFloat = () => {
  const { lang } = useT();
  const label = lang === "en" ? "Book on WhatsApp" : "Marcar no WhatsApp";
  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={label}
      data-testid="whatsapp-float-button"
      className="group fixed bottom-5 right-5 md:bottom-7 md:right-7 z-[60] flex items-center gap-0 hover:gap-3 bg-[#25D366] text-white rounded-full shadow-[0_8px_24px_rgba(37,211,102,0.45)] hover:shadow-[0_10px_30px_rgba(37,211,102,0.6)] transition-all duration-300 p-3.5 md:p-4 hover:pr-5"
    >
      <WhatsAppIcon />
      <span className="max-w-0 group-hover:max-w-[180px] overflow-hidden whitespace-nowrap text-sm font-semibold transition-[max-width] duration-300">
        {label}
      </span>
    </a>
  );
};
